module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/01-e5e2d1badda1919ff3c349bfcabd2a1d.jpg";